<div class="ui modal " id="Login_Modal" style="width:450px;text-align:center">
    <div class="ui inverted segment" style="background:#ffffff">

        <div class="ui inverted form" style="width:450px;">
            <div class="field">
                <div class="ui left icon input">
                    <i class="user icon"></i>
                    <!--<input type="text" name="userName" placeholder="User Name" id="Login_Input_UserName">-->

                    <input  ngfocus="" type="text" placeholder="Email" [(ngModel)]="this.tournamentsService.UserNameValue" data-position="bottom center" name="loginname" id="loginname" #loginname="ngModel" required (focus)="Login_Input_Focus_Username()" (focusout)="Login_Input_FocusOut_Username()" style="background:lavender">
                    <i class="user icon"></i>

                </div>
            </div>
            <div class="field">
                <div class="ui left icon input">
                    <i class="lock icon"></i>
                    <!--<input type="password" name="password" placeholder="Password" id="Login_Input_Password">-->

                    <input type="password" placeholder="Password" [(ngModel)]="this.tournamentsService.UserPasswordValue" id="loginpwd" name="loginpwd" #loginpwd="ngModel" (keypress)="loginEntered($event)" required (focus)="Login_Input_Focus_Password()" (focusout)="Login_Input_FocusOut_Password()"  style="background:lavender">
                    <i class="lock icon"></i>

                </div>
            </div>


            <div class="inline field" style="color: darkred; text-align: center;">


                <span *ngIf="this.loginService.hasLoginError">{{this.loginService.LoginMessageContent}}</span>

            </div>
            <div style="text-align:center">
                <button style="float:left" class="ui icon button" (click)="Open_Keyboard()">
                    <i class="keyboard icon"></i>
                </button>
                <div class="ui mini inverted animated green button" (click)="signIn()">
                    <div class="visible content"><span tkey="SignIn"></span></div>
                    <div class="hidden content">
                        <i class="right arrow icon"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <!--<div class="ui middle aligned center aligned grid" style="height:100%;background-color:black">
        <div class="column">

            <form class="ui large form">
                <div class="ui stacked segment" id="LoginFormBackground">
                    <div class="field">
                        <div class="ui left icon input">
                            <i class="user icon"></i>
                            <!--<input type="text" name="userName" placeholder="User Name" id="Login_Input_UserName">-->

                            <!--<input ddd="" ngfocus="" type="text" placeholder="Email" [(ngModel)]="entry.Email" data-position="bottom center" name="loginname" id="loginname" #loginname="ngModel" required (focus)="Login_Input_Focus_Username()" (focusout)="Login_Input_FocusOut_Username()" value={{this.tournamentsService.UserNameValue}}>
                            <i class="user icon"></i>

                        </div>
                    </div>
                    <div class="field">
                        <div class="ui left icon input">
                            <i class="lock icon"></i>-->
                            <!--<input type="password" name="password" placeholder="Password" id="Login_Input_Password">-->

                            <!--<input type="password" placeholder="Password" [(ngModel)]="entry.Password" id="loginpwd" name="loginpwd" #loginpwd="ngModel" (keypress)="loginEntered($event)" required (focus)="Login_Input_Focus_Password()" (focusout)="Login_Input_FocusOut_Password()" value={{this.tournamentsService.UserPasswordValue}}>
                            <i class="lock icon"></i>

                        </div>
                    </div>



                    <div>
                        <button style="float:left" class="ui icon button" (click)="Open_Keyboard()">
                            <i class="keyboard icon"></i>
                        </button>
                        <div class="ui mini inverted animated green button" (click)="signIn()">
                            <div class="visible content"><span tkey="SignIn"></span></div>
                            <div class="hidden content">
                                <i class="right arrow icon"></i>
                            </div>
                        </div>

                    </div>


                </div>


            </form>
            <div *ngIf="this.loginService.hasLoginError" class="ui error message">
                <div class="header">Error</div>
                <p>{{this.loginService.LoginMessageContent}}</p>
            </div>

        </div>
    </div>-->
<div class="ui modal " id="Login_Keyboard_Modal" style="width:1000px">
    <!--<div class="ui fluid icon action input" style="margin:10px">
        <input placeholder="Find Game" type="text" id="KeyboardSearch_Input" style="text-align:left" value="{{this.KeyboardSearch_Input_Value}}" />
        <button class="ui icon button" (click)="LoginKeyboard_InputClear()">
            <i class="times circle outline large icon"></i>
        </button>

    </div>-->

    <div class="ui grid" style="margin:10px">

        <div style="padding:0">

            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(1)">
                1
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(2)">
                2
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(3)">
                3
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(4)">
                4
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(5)">
                5
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(6)">
                6
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(7)">
                7
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(8)">
                8
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(9)">
                9
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(0)">
                0
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('-')">
                -
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('_')">
                _
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('!')">
                !
            </button>


        </div>

        <div style="padding:0;padding-left:30px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('q')">
                q
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('w')">
                w
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('e')">
                e
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('r')">
                r
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('t')">
                t
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('z')">
                z
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('u')">
                u
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('i')">
                i
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('o')">
                o
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('p')">
                p
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('ü')">
                ü
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('?')">
                ?
            </button>
        </div>


        <div style="padding:0;padding-left:60px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('a')">
                a
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('s')">
                s
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('d')">
                d
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('f')">
                f
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('g')">
                g
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('h')">
                h
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('j')">
                j
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('k')">
                k
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('l')">
                l
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('ö')">
                ö
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('ä')">
                ä
            </button>
        </div>

        <div style="padding:0;padding-left:90px">
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('y')">
                y
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('x')">
                x
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('c')">
                c
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('v')">
                v
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('b')">
                b
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('n')">
                n
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('m')">
                m
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue(',')">
                ,
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('.')">
                .
            </button>
            <button class="LiveBets_Modal_Keyboard_Search_CircleButton" (click)="LoginKeyboard_ChangeValue('')">
                '
            </button>
        </div>

        <div style="padding:0;padding-left:140px">

            <button class="circular ui icon button" style="margin:5px;height:44px;width:370px;float:left; border: 2px solid #BDBDBD;background: linear-gradient(to toppackages#C7C7C7, #FBFBFB);" (click)="LoginKeyboard_ChangeValue(' ')"></button>
            <button class="circular ui icon button" style="margin:5px;height:44px;width:95px; border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="LoginKeyboard_Backspace()">
                <i class="arrow left icon"></i>
            </button>



            <button class="circular ui button" style="margin:5px;height:44px;width:95px;border: 2px solid #BDBDBD;background: linear-gradient(to top, #C7C7C7, #FBFBFB);" (click)="LoginKeyboard_Close()">
                <span tkey="Close"></span>
            </button>
        </div>
    </div>
</div>

    <comp_livebets_keyboard_search_modal></comp_livebets_keyboard_search_modal>
    <comp_terminal_keyboard_modal></comp_terminal_keyboard_modal>
    <style type="text/css">
        body {
            background-color: black;
        }

            body > .grid {
                height: 100%;
            }

        .image {
            margin-top: -100px;
        }

        .column {
            max-width: 450px;
        }

    </style>
